<template>
  <vk-icon v-if="$menu.isOpen" name="chevronup"/>
  <vk-icon v-else name="chevrondown"/>
</template>

<script>
export default {
  name: 'header-menu-chevron',
  inject: ['$menu'],
};
</script>
